import { render } from "./Home.vue?vue&type=template&id=083a8bcf&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=083a8bcf&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-admin/on-the-edge-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__